module.exports = __webpack_public_path__ + "img/kanban05.053b0d2b.png";